<template>
  <div class="app" >
    <el-container style="width:100%;  height: 100vh">

      <el-header class="clear" style=" width:100%;height:60px;font-size: 12px; background-color:#56B8AA">
        <div style="text-align:center; height:60px; line-height:60px; width:117px" class="fl"><img src="../../static/img/log2.png"></div>
        <div class="fr" style="text-align:center; height:60px; line-height:60px">
          <router-link :to="{path:'/ui/settinguser'}" class="headerbut"><i class="iconfont icon-yonghu1"></i><span class="text">{{userInfo.user_name==null?'':userInfo.user_name}}</span> </router-link>
          <router-link :to="{path:$route.path}" class="headerbut"><i class="iconfont icon-logonout"></i><span class="text" @click="loginout">退出登录</span></router-link>
         <!-- <el-select class="mendianbut" @change="selectchange"  value-key="storecode" v-model="store.storename" auto-complete="off">
            <el-option
              v-for="item in storeList"
              :key="item.storecode"
              :label="item.storename"
              :value="item">
            </el-option>
          </el-select> -->
        </div>
      </el-header>
      <div class="clear" style="width:100%">
        <el-breadcrumb separator-class="el-icon-arrow-right" class="breadpos" style="width:100%;height56px;line-height:56px; background-color:#fff">
           <ul>
             <li v-if = "path!==''">
                <el-breadcrumb-item >{{ pathtitle }}</el-breadcrumb-item>
                <el-breadcrumb-item :to="{ path: path }">{{ pathname }}</el-breadcrumb-item>
                <el-breadcrumb-item >{{ pathchuildname }}</el-breadcrumb-item>
             </li>
             <li v-else>
                <el-breadcrumb-item v-if ="pathtitle !==''">{{ pathtitle }}</el-breadcrumb-item>
                <el-breadcrumb-item>{{ pathname }}</el-breadcrumb-item>
             </li>
           </ul>
          <div>
            <el-button v-show="path !== ''" type="primary" class="fr" size="mini" @click="reback(path)" style="margin: 14px; 20px 0 0">返回上一页</el-button>
          </div>
        </el-breadcrumb>
        <NavHeader/>
        <transition name="fade">  <!--  v-bind:style="{width: width+'px'}" -->
          <el-main class="mainpos main-div" ref="mainDiv" style="min-width: 1146px;width:auto">
            <!-- <keep-alive> -->
              <router-view v-if="isRouterAlive"/>
            <!-- </keep-alive> -->
          </el-main>
        </transition>
      </div>
       <!-- Modal  start updatePass-->
    <div class="model updateuser" v-show="updatePass">
      <div class="content clearfix">
        <div class="title">
          <span class="fl">第一次登陆请先修改密码</span>
          <!-- <span class="fr" @click="closePassmodel"><i class="iconfont icon-guanbi"></i></span> -->
        </div>
        <div class="" style="padding: 0 20px">
          <el-form :model="userForm" :rules="rules" ref="userForm" label-width="100px" class="demo-ruleForm my user">

            <el-form-item label="新密码：" prop="pass" class="passlabel">
              <el-input type="password" v-model="userForm.pass" auto-complete="off" style="margin-left: 13px; width:308px;" clearable></el-input>
            </el-form-item>
            <el-form-item label="确认密码：" prop="checkPass" class="passlabel">
              <el-input type="password" v-model="userForm.checkPass" auto-complete="off" style="margin-left: 13px; width:308px;" clearable></el-input>
            </el-form-item>
          </el-form>
        <el-button size="small" type="primary" @click="submitPassForm('userForm')" class="fr">确认修改</el-button>
        </div>
      </div>
    </div>
     <!-- 弹窗 start -->
      <MessageModel types="提示信息" :msg="msg" :msgShow="msgShow" :flag="modelFlag" :butmsg="butmsg" :butflag = "butflag" @modelmsg="returnMsg"></MessageModel>
    <!-- Modal  end-->
    </el-container>
  </div>
</template>
<script>
// import NavHeader from '../components/NavHeader'
import NavHeader from '../components/silder3'
import axios from 'axios'
// import {setCookie,getCookie,delCookie} from '../../static/js/cookie.js'
export default {
  name: 'App',
  provide(){
    return{
      reload:this.reload
    }
  },
  components: {
    NavHeader
  },
  data() {
     const validatePass = (rule, value, callback) => { //密码规则
      if (value.length < 6) {
        callback(new Error('密码不能小于6位'));
      } else if (value === '') {
        callback(new Error('密码不能为空'));
      } else {
         if (this.userForm.checkPass !== '') {
          this.$refs.userForm.validateField('checkPass');
        }
        callback();
      }
    };
    const validateCheckPass = (rule, value, callback) => { //密码规则
      if (value !== this.userForm.pass){
        callback(new Error('两次输入密码不一致!'));
      }else{
        callback();
      }
    };
    return {
      utilpath:'',
      flag:false,
      msgShow:false,
      modelFlag:false,
      butflag:true,
      msg:'',
      butmsg:'确认',
      methodName:'',
      isRouterAlive:true,
      updatePass:false,
      width: 0,
      pathtitle:'',
      pathname:'',
      pathchuildname:'',
      path:'',
      transitionName:'',
      storeList:[],
      userInfo:{},
      store: {
          storecode: '',//门店编码
          storename: ''//门店名称
      },
      userForm:{
        pass:'',
        checkPass:''
      },
      rules: { //验证规则
        pass: [
          { required: true, trigger: 'blur', validator:validatePass  }
        ],
        checkPass: [
          { required: true, trigger: 'blur', validator:validateCheckPass  }
        ]
      },
    };
  },

  mounted() {
    console.log("Full内打印接口"+axios.defaults.baseURL);
    this.utilpath = this.axios.defaults.baseURL;
    this.userInfo = JSON.parse(window.localStorage.getItem("userInfo"));
    // console.log("第二个开始"+window.location.hash.slice(1));
    // console.log("全部："+window.location.hash);
    this.init();
    /*this.isUser();documentElement*/
    this.width = `${document.documentElement.clientWidth}`-220
      window.onresize = function temp() {
        this.width = `${document.documentElement.clientWidth}`-220
      };
  },
  beforeDestroy() {
   // console.log("1111111111111111111111111111111111111111111111111111111Full页面销毁前")
    sessionStorage.clear();
    window.localStorage.clear();
  },

  watch: {//使用watch 监听$router的变化
    // 如果 `clientHeight` 发生改变，这个函数就会运行
      width: function () {
        this.changeFixed(this.width)
      },
    $route(to, from) {
      // var user_code = getCookie('user_code');
      // if (user_code == '' || user_code == 'undefind') {
      //    this.$router.push({path:'/ui/login',query:{msg:0}});
      var path = to.path;
      this.pathconfigure(path);
      //如果to索引大于from索引,判断为前进状态,反之则为后退状态
      if(path !== ''){
        //设置动画名称
        this.transitionName = 'slide';
      }

    }
  },
  methods: {
    closePassmodel(){
      this.updatePass = false;
    },
     isDo() {
          this.$http.post(this.utilpath0 + '/checklogin',  { emulateJSON: true}).then((res) => {
                if(res.data.status == '9'){
                  this.$router.push({path:'/ui/login',query:{msg:9}});
                }else if(res.data.status == '-9'){
                  this.$router.push({path:'/ui/login',query:{msg:2}});
                }
              }, (err) => {
                console.log(JSON.stringify(err));
              });
      } ,
    returnMsg(flag){
      this.modelFlag = false;
      if(flag){
            // console.log("---进来了！！！----"+this.methodName);
            if(this.methodName =='updatepass'){
                 var reqparams={
                  userCode:this.userInfo.user_code,
                  password: this.userForm.checkPass,
                  updatefalg: '1'
                }
               // console.log("---参数！！！----"+JSON.stringify(reqparams));
                this.$http.post(this.utilpath+'/updateUser',reqparams,{emulateJSON:true,_timeout:600}).then((res)=>{
                    if(res.data.status == '0'){
                        this.updatePass = false;
                        this.$message({
                          showClose:true,
                          message:'修改成功',
                          type:'success'
                        })
                        this.msgShow =false;
                        this.userInfo.vdef1='2'
                        sessionStorage.setItem("userInfo", JSON.stringify(this.userInfo));
                        window.localStorage.setItem("userInfo", JSON.stringify(this.userInfo));
                    }else{
                      this.modelFlag = true;
                      this.msgShow = true;
                      this.methodName = 'message';
                      this.msg = res.data.message;
                      this.butflag =false;
                      this.butmsg='知道了';
                    }
                }, (err) => {
                      this.modelFlag = true;
                      this.msgShow =false;
                      this.methodName = 'message';
                      this.msg = '连接修改密码接口失败'+err;
                      this.butflag =false;
                      this.butmsg='知道了';
                    console.log(err);
                })
            }
      }else{
        this.$message({
          showClose:true,
          message:'已取消',
          type:'succcess'
        })
      }
    },
    submitPassForm(formName){
        this.$refs[formName].validate((valid) => {
        if (valid) {
             // console.log("打印要提交的用户参数："+JSON.stringify( this.userForm));
              this.methodName = 'updatepass';
              this.modelFlag = true;
              this.msgShow =false;
              this.butflag = true;
              this.butmsg='确认';
              this.msg = '确定提交修改？'
        } else {
         // console.log('输入有误，请重输！');
          return false;
        }
      });
    },
    reload(){
      this.isRouterAlive = false;
      this.$nextTick(function(){
          this.isRouterAlive = true;
      })
    },
    changeFixed(clientWidth){                        //动态修改样式
       // console.log("查看宽度1：--》"+clientWidth);
        //this.$refs.mainDiv.style.width = clientWidth+'px';

      },
    isUser(){
      // var msg = this.$store.state.userInfo.user_name;
      // if(msg == '' || msg == 'undefind'){
      //    this.$router.push({path:'/ui/login',query:{msg:0}});
      // }
    },
    reback(path){
      this.$router.push({ path: path });//跳转页面
    },
     selectchange(value){
        //  console.log("下拉变化事件"+JSON.stringify(value)+"下标：");
          this.store={
            storecode:value.storecode,
            storename:value.storename
          }
        //  console.log("下拉变化事件"+JSON.stringify(this.store)+"下标：");
          this.userInfo=JSON.parse(sessionStorage.getItem("userInfo"))
          this.userInfo.storecode=value.storecode;
          this.userInfo.storename=value.storename;
          sessionStorage.setItem("userInfo",JSON.stringify(this.userInfo));
          if(this.$route.path!='/ui/receives/rqinggou'){

          this.$router.push({ path: '/ui/receives/rqinggou' });//跳转页面
          }else{
            window.location.reload();
          }
    },
    pathconfigure(msg){
        var pathname=this.$route.name;
        var path = msg;
        var str = path.substring(0, 9);
        if (str == '/ui/stock') {
            this.pathtitle = '库存变更';
        }else if (str == '/ui/recei') {
            this.pathtitle = '门店收货';
        }else if (str == '/ui/order') {
            this.pathtitle = '门店请购单';
        }else if (str == '/ui/syste') {
            this.pathtitle = '系统管理';
        }else{
          this.pathtitle ='';
          this.pathname = pathname;
        }
        if(pathname == '填写调出单'){
          this.pathname = '确认调拨';
          this.pathchuildname = '填写调出单';
          this.path = '/ui/stock/diaochu';
        }else if (pathname == '货位明细') {
          this.pathname = '货位调整';
          this.pathchuildname = '货位明细';
          this.path = '/ui/stock/huowei2';
        }else if (pathname == '新增调整') {
          this.pathname = '货位调整';
          this.pathchuildname = '新增调整';
          this.path = '/ui/stock/huowei2';
        }else if (pathname == '新调货位') {
          this.pathname = '货位调整';
          this.pathchuildname = '新增调整';
          this.path = '/ui/stock/huowei';
        }else if (pathname == '新增盘点单') {
          this.pathname = '库存盘点';
          this.pathchuildname = '新增盘点单';
          this.path = '/ui/stock/pandi';
        }else if (pathname == '新增申请') {
          this.pathname = '申请调拨';
          this.pathchuildname = '新增申请';
          this.path = '/ui/stock/diaobo';
        }else if (pathname == '新增用户') {
          this.pathname = '用户管理';
          this.pathchuildname = '新增用户';
          this.path = '/ui/system/authority';
        }else if (pathname == '新增角色') {
          this.pathname = '角色管理';
          this.pathchuildname = '新增角色';
          this.path = '/ui/system/roleManage';
        }else if (pathname == '新增退货单') {
          this.pathname = '商品退货';
          this.pathchuildname = '新增退货单';
          this.path = '/ui/order/qutuihuo';
        }else if (pathname == '新增销售出库单') {
          this.pathname = '货品出库';
          this.pathchuildname = '新增货品出库单';
          this.pathchuildname = '货品出库';
          this.path = '/ui/stock/xiaochu';
        }else{
          this.pathname = pathname;
          this.path = '';
        }
       // console.log("打印路由"+this.$route.name);
    },
    init() {
      var path = this.$route.path;
      this.pathconfigure(path);
      // var user_code = getCookie('user_code');
      // var users = JSON.parse(window.localStorage.getItem("userInfo"));
    //  console.log("打印当前时间："+parseInt(Date.parse(new Date())));
       // console.log("222打印传递的用户："+JSON.stringify(users));

      // if(users==null){
      //   this.$router.push({
      //     path: '/ui/login',query:{msg:-1}
      //   });
      // }else{
        // this.userInfo=users;
      //  console.log("打印状态"+this.userInfo.vdef1)
        if(this.userInfo.vdef1=='1'){
            this.updatePass = true;
        }
      //  console.log("打印updatePass"+this.updatePass)
        // var timeflag = parseInt(users.outtime)+ parseInt(users.localdate) >= parseInt(Date.parse(new Date()));
        // if (users.user_code == '' || users.user_code == 'undefind') {
        //    this.$router.push({
        //     path: '/ui/login'
        //   });
        // };
        // if (timeflag) {
        //    this.$router.push({
        //     path: '/ui/login',query:{msg:0}
        //   });
        // };
      //   this.userInfo = users;
      // }

      // var users = JSON.parse(localStorage.getItem("userInfo"));

    // this.getstore();
  },
  getstore(){
              //获取数据接口
                this.$http.post(this.utilpath+'/selectPoOrderInfo', reqParams,{emulateJSON:true}).then((res) => {
                // this.$http.post('/ktnapi/selectPoOrderInfo', reqParams,{emulateJSON:true}).then((res) => {
                // this.$http.post(this.InterfacePath+'/selectPoOrderInfo', reqParams,{emulateJSON:true}).then((res) => {
                    if(res.data.status == '0'){
                        var stores=res.data.result;
                        this.storeList=[];
                        for(var i=stores.length-1;i>-1;i--){
                            this.storeList.push({storename:stores[i].storename,storecode:stores[i].storecode});
                        }
                       // console.log("打印货位"+JSON.stringify(this.storeList));
                    } else if(res.data.status == '9'){
            this.$router.push({path:'/ui/login',query:{msg:9}});
        } else{


                    }

                }, (err) => {
                   this.$alert('连接接口失败', '失败信息', {
                      confirmButtonText: '确定'
                    });
                    console.log(err);
                });
    },
    changestore(item){

    },
  loginout() {
    /*删除cookie*/
    // delCookie('user_code');

    //获取数据接口
    this.$http.post(this.utilpath+'/loginOut',{emulateJSON:true}).then((res) => {
    //  console.log("打印退出返回结果:"+JSON.stringify(res.data));
        if(res.data.status == '0'){
            sessionStorage.clear();
            window.localStorage.clear();
            this.$router.push({
              path:'/ui/login'
            });
           // console.log("打印货位"+JSON.stringify(this.storeList));
        }else{
          this.fullscreenLoading = false;
          this.modelFlag = true;
          this.msgShow =false;
          this.msgShow = true;
          this.methodName = 'message';
          this.msg = res.data.message;
          this.butflag =false;
          this.butmsg='知道了';
        }

    }, (err) => {
        this.fullscreenLoading = false;
          this.modelFlag = true;
          this.msgShow =false;
          this.methodName = 'message';
          this.msg = '连接退出接口失败';
          this.butflag =false;
          this.butmsg='知道了';
        console.log(err);
    });

  }
}
}
</script>
<style>
.fade-enter-active, .fade-leave-active {
  transition: opacity .9s;
}
.fade-enter, .fade-leave-to {
  opacity: 0;
}
</style>



// WEBPACK FOOTER //
// src/views/Full.vue